import React from 'react';
// Constants
import {
  CompanyName,
  CompanyTagLine,
  FULL_BUSINESS_URL,
  KeywordsPages,
} from '../../utils/constants/Constants';
import { GALLERY_PAGE_URL, HOME_PAGE_URL } from '../../utils/constants/Routes';

// Data
import {
  galleryPageAdditionalMeta,
  galleryPageStructuredData,
} from '../../utils/data/MetaData';

// Components
import Navbar from '../../components/nav/Navbar';
import { HelmetItem } from '../../components/utils/HelmetItem';
import GalleryPageMainContainer from '../../components/gallery/GalleryPageMainContainer';

// Utils
import { buildBreadcrumbLd } from '../../utils/seo/breadcrumbs';
import FAQSchema from '../../utils/seo/FAQSchema';
import { galleryPageFaqItems } from '../../utils/data/faqSchemas';

function GalleryPage() {
  const breadcrumbLd = buildBreadcrumbLd({
    baseUrl: FULL_BUSINESS_URL,
    items: [
      { label: 'Home', href: HOME_PAGE_URL },
      { label: 'Gallery', href: GALLERY_PAGE_URL },
    ],
  });

  return (
    <>
      {/* Tab Data */}
      <HelmetItem
        PageName="Gallery"
        desc={`Enter the realm of ${CompanyName}, where strength, seduction, and dominance collide. A curated gallery revealing My power, presence, and irresistible command.`}
        keywords={KeywordsPages}
        additionalMeta={galleryPageAdditionalMeta}
        structuredData={[galleryPageStructuredData, breadcrumbLd]}
        canonicalPath={GALLERY_PAGE_URL}
      />

      {/* Page */}
      <div className="grid relative min-h-screen font-poppins bg-colour2 dark:bg-colour2 text-colour1 dark:text-colour1">
        <div className="grid min-h-screen">
          {/* Navigation */}
          <Navbar />

          {/* Header */}
          <header className="pt-24 px-6 lg:container lg:mx-auto lg:px-24">
            <h1
              aria-label={`Gallery of ${CompanyName}`}
              className="text-center font-titleFont text-6xl lg:text-6xl tracking-widest"
            >
              Personal Gallery
            </h1>

            <div className="mx-auto grid justify-center">
              <h2 className="text-xl xs:text-2xl mt-1 sm:text-3xl md:text-4xl lg:text-4xl lg:py-2 text-center">
                {CompanyTagLine}
              </h2>
            </div>
          </header>

          {/* Main page content */}
          <GalleryPageMainContainer />
        </div>

        {/* FAQ JSON-LD */}
        <FAQSchema items={galleryPageFaqItems} />
      </div>
    </>
  );
}

export default GalleryPage;
